import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { CardActions, Button, Modal, Box, Stack } from '@mui/material';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import '../App.css'; // Import your stylesheet

const style = {
    position: 'absolute', 
    top: '50%', 
    left: '50%', 
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '70%', md: '60%', lg: '50%' }, // Responsive width
    bgcolor: 'background.paper', 
    boxShadow: 24, 
    p: 4, 
    overflowY: 'auto', 
    maxHeight: '90vh' 
  };

  function truncateText(text, maxLength) {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  }
  

  const CustomCard = ({ title, images, description, actions }) => {
    const [open, setOpen] = useState(false);
    const descriptionMaxLength = 200; // Maximum length for the description
    const cardMaxHeight = 400; // Maximum height for the card
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    const truncatedDescription = truncateText(description, descriptionMaxLength);
  
    return (
      <Card sx={{ maxWidth: '100%', maxHeight: cardMaxHeight, m: 1, overflow: 'auto' }}> {/* Set max width, max height, margin, and overflow */}
        <CardMedia
          component="img"
          height="140"
          image={images[0]}
          alt={title}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {truncatedDescription}
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" variant="outlined" onClick={handleOpen}>Learn More</Button>
        </CardActions>
  
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <ImageGallery 
              items={images.map(image => ({ original: image, thumbnail: image }))} 
              additionalClass="custom-image-gallery" 
              showPlayButton={false} 
              showThumbnails={false} 
              showFullscreenButton={false}
            />
            <Stack spacing={2} sx={{ mt: 2 }}>
              <Typography id="modal-modal-title" variant="h6" component="h2">
                {title}
              </Typography>
              <Typography id="modal-modal-description">
                {description}
              </Typography>
            </Stack>
            {actions && actions.map((action, index) => (
              <Button key={index} variant="contained" sx={{mr: 1, mt: 3}} onClick={() => window.open(action.url)}>{action.name}</Button>
            ))}
          </Box>
        </Modal>
      </Card>
    );
  };
  
  

export default CustomCard;
